<template>
  <el-dialog
    :visible.sync="DialogShow"
    @closed="closeDialog"
    @open="openDialog"
    append-to-body
  >
    <div slot="title" class="dialog-title">
      <span class="title-line"></span>
      <span class="title-text">{{ title }}</span>
    </div>
    <el-form
      :model="submitFormData"
      :rules="rules"
      ref="form"
      label-width="160px"
      class="demo-submitFormData"
      style="padding: 20px 0 10px 60px"
    >
      <el-form-item label="标题" prop="title">
        <el-input v-model="submitFormData.title" class="long-inp"></el-input>
      </el-form-item>
      <el-form-item label="上传背景图" prop="pictureBid">
        <el-upload
          class="avatar-uploader"
          :action="`${uploadfileUrl}/fileManager/uploadPicture`"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleAvatarError"
          :before-remove="handleAvatarRemove"
          :on-change="uploadChange"
          :before-upload="beforeFileUpload"
          name="file"
          :headers="{ token }"
        >
          <img
            v-if="titlePictureUrl"
            :src="titlePictureUrl"
            class="avatar"
            @click="iconUpdataClick"
          />
          <el-button v-else size="small" type="primary" @click="iconUpdataClick"
            >选取图片</el-button
          >
        </el-upload>
      </el-form-item>
      <el-form-item label="选择国家" prop="resourceBid">
        <el-select
          v-model="submitFormData.resourceBid"
          class="long-inp"
          placeholder="请选择"
        >
          <el-option
            v-for="item in countryList"
            :key="item.countryBid"
            :label="item.countryName"
            :value="item.countryBid"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="from-btn-wrap">
      <el-button type="primary" @click="handelClickSubmit" size="small">{{
        upDataMsg
      }}</el-button>
      <el-button type="primary" plain size="small" @click="handelClickCancel"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  visaApplicantInformationCreate,
  visaApplicantInformationGetDetail,
  visaApplicantInformationUpdate,
  getInformationType,
} from '@/api/home';
import { countryGetAll } from '@/api/country';
import { clone } from '@/utils/utils';
const defaultUpdataObj = {
  resourceBid: '',
  isShow: 1,
  linkType: 3,
  title: '',
  pictureBid: '',
  bannerBid: '',
};
export default {
  data() {
    return {
      upDataMsg: '保存',
      token: '',
      DialogShow: false,
      submitFormData: clone(defaultUpdataObj),
      imgType: '',
      rules: {
        title: [{ required: true, message: '请输入资料名称', trigger: 'blur' }],
      },
      titlePictureUrl: '',
      exampleFileUrl: '',
      countryList: [],
    };
  },
  props: {
    title: {
      type: String,
      default: function () {
        return '';
      },
    },
    informationBid: {
      type: String,
      default: '',
    },
  },
  methods: {
    openDialog() {
      this.getInformationTypeFunc();
      this.token = localStorage.getItem('token');
      console.log(this.informationBid);
      if (this.informationBid) {
        //编辑
        console.log(this.informationBid);
        visaApplicantInformationGetDetail(this.informationBid).then((res) => {
          if (res.code == 200) {
            this.titlePictureUrl = res.data.imageUrl;
            Object.assign(this.submitFormData, res.data);
            console.log(this.titlePictureUrl);
            this.submitFormData.bannerBid = this.informationBid;
          }
        });
      } else {
        this.submitFormData = Object.assign({}, defaultUpdataObj);
        this.exampleFileUrl = '';
        this.titlePictureUrl = '';
      }
    },
    getInformationTypeFunc() {
      countryGetAll().then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.countryList = res.data;
        }
      });
    },
    handelClickCancel() {
      this.closeDialog();
    },
    closeDialog() {
      this.DialogShow = false;
      this.$refs.form.resetFields();
    },
    iconUpdataClick() {
      this.imgType = 'iconImg';
    },
    exampleImgClick() {
      this.imgType = 'exampleImg';
    },
    removeDomain(item) {
      var index = this.submitFormData.descriptionList.indexOf(item);
      if (index !== -1) {
        this.submitFormData.descriptionList.splice(index, 1);
      }
    },
    addDomain() {
      this.submitFormData.descriptionList.push('');
    },
    handelClickSubmit() {
      if (this.upDataMsg == '保存') {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.upDataMsg = '保存中..';
            if (!this.informationBid) {
              visaApplicantInformationCreate(this.submitFormData).then(
                (res) => {
                  if (res.code == 200) {
                    this.$msg.success('保存成功！');
                    this.$emit('upData');
                    this.closeDialog();
                  }
                }
              );
              this.upDataMsg = '保存';
            } else {
              visaApplicantInformationUpdate(this.submitFormData).then(
                (res) => {
                  if (res.code == 200) {
                    this.$msg.success('保存成功！');
                    this.$emit('upData');
                    this.closeDialog();
                  }
                }
              );
              this.upDataMsg = '保存';
            }
          }
        });
      }
    },
    //上传部分--------------------------------------------------------
    handleAvatarSuccess(res) {
      this.duration = 10;
      this.$msg.success('上传成功');
      this.duration = 0;
      if (this.imgType == 'iconImg') {
        this.titlePictureUrl = res.data.fileUrl;
        console.log(this.titlePictureUrl);
        this.submitFormData.pictureBid = res.data.fileBid;
        this.$refs.form.clearValidate('pictureBid');
      } else if (this.imgType == 'exampleImg') {
        this.exampleFileUrl = res.data.fileUrl;
        this.submitFormData.exampleFileBid = res.data.fileBid;
        this.$refs.form.clearValidate('exampleFileBid');
      }
    },
    handleAvatarError(error) {
      console.log(error);
      this.$msg.error('上传失败');
    },
    handleAvatarRemove() {
      this.$msg.error('上传失败!');
    },
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    uploadChange(file, fileList) {
      this.fileList = fileList;
    },
    isImage(fileName) {
      if (typeof fileName !== 'string') {
        return;
      }
      let name = fileName.toLowerCase();
      return name.endsWith('.png') || name.endsWith('.jpg');
    },
    beforeFileUpload(file) {
      if (this.submitFormData.exampleType == 0) {
        const isLt10M = file.size / 1024 / 1024 < 10;
        let type = this.isImage(file.name);
        console.log(type);
        let fileLength = this.fileList.length;
        if (!isLt10M) {
          this.$message.error('上传文件大小不能超过 10MB!');
          return;
        } else if (!type) {
          // 若不符合图片类型，则让当前上传的文件去除掉即可，即从上传对列删除本次上传
          this.fileList.splice(fileLength - 1, 1);
          this.$msg.error('只允许上传jpg、png，且文件大小不能超过 10MB!');
          return;
          // this.type = false;
        } else {
          // this.type = true;
          this.$msg({
            duration: this.duration,
            message: '上传中',
            showClose: true,
          });
        }
        return isLt10M && type;
      }
    },
  },
  computed: {
    uploadfileUrl() {
      return this.$conf.visaService;
    },
  },
};
</script>

<style scoped lang="scss">
.avatar {
  width: 100px;
  height: 100px;
}
.right-link {
  padding: 0 10px;
}
</style>